import { CommonModule } from '@angular/common';
import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';

@Component({
  selector: 'idp-search-modal-icon',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './search-modal-icon.component.html',
  styleUrls: ['./search-modal-icon.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchModalIconComponent {
  @ViewChild('triggerElement') triggerElement!: ElementRef;
  @Output() openFlyout = new EventEmitter();
  @Output() analyticsEvent = new EventEmitter<HTMLElement>();
  openFlyoutSearch(): void {
    this.openFlyout.emit();
  }

  handleFocusEvent(event: KeyboardEvent): void {
    if (event.key === 'ENTER') {
      this.triggerElement.nativeElement.blur();
    }
  }

  analyticsEventEmit(event: Event): void {
    const element = event.currentTarget as HTMLElement;
    this.analyticsEvent.emit(element);
  }
}
